export default __webpack_public_path__ + "static/media/hht2_direction_speakingpractice_03.4bae8a1f.png";